module.exports = __webpack_public_path__ + "static/img/face20.9c095f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face20.jpg
// module id = 3vHR
// module chunks = 0